import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchOrderDetails, getV2InternetProduct, getVoiceProduct } from "../../../../shared/hooks/useFetchServiceDetails";
import API_URLS from "../../Utils/axr";
import store from "../store";
import { PURGE } from "redux-persist";

type getProductCategoriesStateType = {
  productResponse: any;
  internetProductLoading: boolean;
  dslInternetProductResponse: any;
  dslInternetProductLoading: boolean;
  voiceProductLoading: boolean;
  dslVoiceProductLoading: boolean;
  dslVoiceProductResponse: any;
  existingProductLoading: boolean;
  error: any;
  productVoiceRes:any;
  voipProducts:any;
  baseline:any;
  address:any;
  existingOrderDetails:any;
  selectedAppointmentTimeslotData?: any;
};
const initialState: getProductCategoriesStateType = {
  productResponse: {},
  error: null,
  productVoiceRes: {},
  voipProducts: null,
  baseline: {},
  address: {},
  existingOrderDetails: null,
  internetProductLoading: false,
  dslInternetProductLoading: false,
  dslInternetProductResponse: {},
  voiceProductLoading: false,
  dslVoiceProductLoading:false,
  dslVoiceProductResponse: {},
  existingProductLoading: false,
  selectedAppointmentTimeslotData: null
};
export const getV2InternetProductData = createAsyncThunk(
  "product/shopExp",
  async (_,{rejectWithValue}) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const siteId=reduxStore?.addressQualification?.data?.addressQualification?.entity 
      ?.siteId || headers?.siteId?.toLowerCase();
      let supplementOrderEligible = reduxStore?.brightSpeedUserUtils?.isSupplementOrderEligible;
      let isMoveSupplementOrderEnabled = reduxStore?.brightSpeedUserUtils?.isMoveSupplementOrderEligible;
      let isPostPaidFiberUser = reduxStore?.brightSpeedUserUtils?.isPostPaidFiberUser;
      const serviceDetails= reduxStore?.serviceDetails?.serviceDetails;
      let productId:any;
      if(serviceDetails?.subscriptions?.length > 0) {
        for (let index = 0; index < serviceDetails?.subscriptions[0]?.serviceDetails.length; index++) {
            const element = serviceDetails?.subscriptions[0]?.serviceDetails[index];
            if( element?.serviceType?.includes("Internet")) {
             productId =(element?.serviceModel)
            }
          }
        }
      let serviceModelProductId = productId?.substring(0, productId.length - 1);
      
      const planDetails = reduxStore?.planDetails?.planDetails;                    
      const affinityDiscountApplicable = planDetails && planDetails?.discountPlans?.find((affinityApplicable:any) => affinityApplicable?.productName?.includes("Affinity Discount"));
      // const affinityDiscountZuoraResponse = reduxStore?.fetchOrderDetailsv2?.existingOrderDetails && reduxStore?.fetchOrderDetailsv2?.existingOrderDetails?.discountPlans?.find((affinityApplicable:any) => affinityApplicable?.productName?.includes("Affinity Discount"));
     
      // Robust check for autopay/PMT discount on the customer's plan.
      let hasAutopayOrPmtDiscount = false;
      if (Array.isArray(planDetails?.standardPlans)) {
        const matchedPlan = planDetails.standardPlans.find((plan: any) => {
          // match by common identifiers: productId, productRatePlanId, productSku
          if (!serviceModelProductId) return false;
          return (
            plan?.productId === serviceModelProductId ||
            plan?.productRatePlanId === serviceModelProductId ||
            plan?.productSku === serviceModelProductId ||
            // fallback: sometimes serviceModelProductId may be a substring of ratePlanName
            (typeof plan?.ratePlanName === 'string' && plan.ratePlanName.toLowerCase().includes((serviceModelProductId || '').toLowerCase()))
          );
        });
        if (matchedPlan) {
          hasAutopayOrPmtDiscount = !!matchedPlan.hasAutopayOrPmtDiscount;
        } else {
          // Fallback: if any standard plan has the flag, assume it's true
          hasAutopayOrPmtDiscount = planDetails.standardPlans.some((p: any) => p?.hasAutopayOrPmtDiscount === true);
          // Final fallback: inspect discount sets for known autopay codes/descriptions
          if (!hasAutopayOrPmtDiscount) {
            hasAutopayOrPmtDiscount = planDetails.standardPlans.some((p: any) =>
              Array.isArray(p?.activetoDiscountsSet) && p.activetoDiscountsSet.some((d: any) => {
                const code = (d?.Disccode || '').toString().toLowerCase();
                const desc = (d?.Discdescription || '').toString().toLowerCase();
                return code.includes('apwppldisc') || desc.includes('autopay') || desc.includes('paperless');
              })
            );
          }
        }
      }
      let  zuoraRatePlanId = "";
      if (planDetails?.standardPlans?.length > 0) {
        for (
          let index = 0;
          index < planDetails?.standardPlans?.length;
          index++
        ) {
          const element = planDetails?.standardPlans[index];
          if (element?.productName?.toLowerCase()?.includes("internet")) {
            zuoraRatePlanId = element?.productRatePlanId;
          }
        }
      }
      const wireCenter =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.wireCenter;
      const mmmCode =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.marketingProfile?.mmmCode;
      const uploadSpeed =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.qualificationDetails?.maxUpBandwidth;
      const downloadSpeed =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.qualificationDetails?.maxDownBandwidth;
      const affinityOccupation = (affinityDiscountApplicable && affinityDiscountApplicable?.affinityOccupation) ;
         
      const productsRequest = {
        propertyId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.propertyId,
        fullAddress: reduxStore?.addressQualification?.data?.addressQualification?.entity?.fullAddress,
        instantInternet: reduxStore?.addressQualification?.data?.addressQualification?.entity?.instantInternet,
        mmmCode: mmmCode,
        uploadSpeed: uploadSpeed,
        downloadSpeed: downloadSpeed,
        customerType: null,
        marketSegment: "",
        qualForExternalVideo: false,
        customerGroupType: affinityOccupation,
        productId: serviceModelProductId,
        ratePlanId: zuoraRatePlanId,
        hasAutopayOrPmtDiscount: Boolean(planDetails?.autoPayEligible) || hasAutopayOrPmtDiscount
      };
      const payload = {
        baseline: {
          transactionId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId,
          partnerOrderId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId,
          partnerReferenceId: "",
          agentId:"",
          siteId: siteId,
          wirecenter: wireCenter,
          intent: isMoveSupplementOrderEnabled ? "supplement" : '',
          ...((isMoveSupplementOrderEnabled || isPostPaidFiberUser) && {billingType: "postpaid"}),
          revisionType: isMoveSupplementOrderEnabled ? "supplement" : "",
          channel: "web-acm",
          workflow: isMoveSupplementOrderEnabled ? "mover" : supplementOrderEligible ?"buyflow":"change",
          // ...(supplementOrderEligible && { revisionType: "supplement" }),
        },
        productsRequest
      };
      const params = {
        "": [API_URLS?.getV2InternetProduct],
      };
      const response = await getV2InternetProduct(params, payload, headers);
      if(response?.data?.messageStatus[0]?.status === 500){
        throw response?.data?.messageStatus[0]?.statusMessage
      }else{
        return response.data;
      }
      
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  {
    // Skip only if a request is already in flight (prevents same-tick duplicate dispatches
    // from multiple components). Explicit refetches after data is loaded are still allowed.
    condition: (_arg, { getState }) => {
      const state: any = getState();
      const slice = state?.getProductCategoriesSlice;
      if (slice?.productResponse && Array.isArray( slice?.productResponse?.productResponse?.productDetails)){
        return false;
      } 
      if (slice?.internetProductLoading) return false;
      return true;
    },
  }
);

export const getV2DSLInternetProductData = createAsyncThunk(
  "product/DSLProducts",
  async (_,{rejectWithValue}) => {
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const user= reduxStore?.user?.data;
      const siteId=reduxStore?.addressQualification?.data?.addressQualification?.entity 
      ?.siteId || headers?.siteId?.toLowerCase();
      const serviceDetails= reduxStore?.serviceDetails?.serviceDetails;
      let baseline: any = {};
      let productRequest: any = {};
      let dslService : any[] = [];
      let pricePlanCode = [];
      let bundleCode = [];
      let productId:any;
      if(serviceDetails?.subscriptions?.length > 0) {
        for (let index = 0; index < serviceDetails?.subscriptions[0]?.serviceDetails.length; index++) {
            const element = serviceDetails?.subscriptions[0]?.serviceDetails[index];
            if( element?.serviceType?.includes("Internet")) {
             productId =(element?.serviceModel)
            }
          }
        }
      let serviceModelProductId = productId?.substring(0, productId.length - 1);

     const planDetails = reduxStore?.planDetails?.planDetails;                    
      // const affinityDiscountApplicable = planDetails && planDetails?.discountPlans?.find((affinityApplicable:any) => affinityApplicable?.productName?.includes("Affinity Discount"));
     let  zuoraRatePlanId = "";
      if (planDetails?.standardPlans?.length > 0) {
        for (
          let index = 0;
          index < planDetails?.standardPlans?.length;
          index++
        ) {
          const element = planDetails?.standardPlans[index];
          if (element?.productName?.toLowerCase()?.includes("internet")) {
            zuoraRatePlanId = element?.productRatePlanId;
          }
        }
      }

      const wireCenter =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.wireCenter;
            const mmmCode =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.marketingProfile?.mmmCode;
      const uploadSpeed =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.qualificationDetails?.maxUpBandwidth;
      const downloadSpeed =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.qualificationDetails?.maxDownBandwidth;
      const fiberVoiceEligible = reduxStore?.addressQualification?.data?.addressQualification?.entity?.fiberVoiceEligible || false;
      const transactionId = reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId;
        if (serviceDetails?.subscriptions?.length > 0) {
          serviceDetails?.subscriptions[0]?.serviceDetails?.forEach(
            (product: any) => {
              if (
                product?.serviceType?.toLowerCase() === 'copper dsl' &&
                (product?.serviceState?.toLowerCase() === 'active')
              ) {
                dslService?.push(product?.serviceModel);
                if (product?.isParent?.toLowerCase() === 'true') {
                  const result = planDetails?.standardPlans?.find(
                    (plan:any) =>
                      plan?.productId === product?.serviceModel
                  );
                  productRequest.productId = result?.productId;
                  productRequest.productRatePlanId = result?.productRatePlanId;
                  productRequest.currentPlanPrice = result?.planPrice;
                }
              }
            }
          );
         
          for (const plan of planDetails?.standardPlans ?? []) {
            if (dslService?.includes(plan?.productId)) {
              pricePlanCode.push(plan?.productRatePlanId);
              bundleCode.push(plan?.bundleCode);
            }
          }
          // productsRequest.currentPlanPrice = legacyCustomerInfo?.legacyInternetPrice;
          productRequest.pricePlanCode = [...new Set(pricePlanCode)]
          productRequest.bundleCode = bundleCode;
        }
        baseline.partnerId = "BS196123";
        baseline.salesCode = "20000660";
        baseline.channel = "web-acm";
        baseline.workflow =  "migratecoppertofiber";
        baseline.billingType = "postpaid";
 
        productRequest.speed = uploadSpeed;
        productRequest.productType = "FD";
        productRequest.billingType = "postpaid";
        productRequest.fiberVoiceEligible = fiberVoiceEligible;
        delete productRequest.ratePlanId;
    
        let productsRequest = { 
        addressDetailId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.addressId, 
        marketSegment: "", 
        qualForExternalVideo: false, 
        propertyId: "", 
        fullAddress: reduxStore?.addressQualification?.data?.addressQualification?.entity?.fullAddress,
        instantInternet: reduxStore?.addressQualification?.data?.addressQualification?.entity?.instantInternet, 
        customerType: null, 
        productType: "FD", 
        speed: uploadSpeed, 
        mmmCode: mmmCode, 
        uploadSpeed: uploadSpeed, 
        downloadSpeed: downloadSpeed, 
        pricePlanCode: productRequest.pricePlanCode,
        bundleCode: productRequest.bundleCode || null,
        billingType: productRequest.billingType,
        fiberVoiceEligible: fiberVoiceEligible,
        productId: productRequest.productId, 
        productRatePlanId: productRequest.productRatePlanId, 
        currentPlanPrice: productRequest.currentPlanPrice

    } 
      const payload = 
        { 
        baseline: {
          transactionId: transactionId,
          partnerOrderId: transactionId,
          partnerId: baseline?.partnerId,
          salesCode: baseline?.salesCode,
          partnerReferenceId: "",
          agentId: "",
          channel: baseline?.channel,
          siteId: siteId,
          wirecenter: wireCenter,
          intent: user?.billingType?.toLowerCase() === "prepaid"  ? "dsl_migration" : "",
          workflow: baseline?.workflow,
          billingType: baseline.billingType
        }, 
        productsRequest
      };

      
      const params = {
        "": [API_URLS?.getV2InternetProduct],
      };
      const response = await getV2InternetProduct(params, payload, headers);
      if(response?.data?.messageStatus[0]?.status === 500){
        throw response?.data?.messageStatus[0]?.statusMessage
      }else{
        return response.data;
      }
      
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const fetchOrderDetailsv2 = createAsyncThunk(
  "product/shopExpv2",
  async (_,{rejectWithValue}) => {
    try {
      
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const BAN= reduxStore?.user?.data?.billingAccountNumber
      const orderPayload = {
        transactionId:reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId,
        "accountNumber": BAN
      }
      // const params = {
      //   "": [API_URLS?.zuoraProductDetailsvoice],
      // };
      // const response = await fetchOrderDetails(params, orderPayload, headers);
      // return response.data;
    }
    catch (error) {
      return rejectWithValue(error);
    } 
  }
);
export const getV2VoiceProducts = createAsyncThunk(
  "voiceproduct/shopExp",
  async (_,{rejectWithValue}) => {
    
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const siteId=reduxStore?.addressQualification?.data?.addressQualification?.entity?.siteId;
      let supplementOrderEligible = reduxStore?.brightSpeedUserUtils?.isSupplementOrderEligible;
      let isMoveSupplementOrderEnabled = reduxStore?.brightSpeedUserUtils?.isMoveSupplementOrderEligible;
      const wirecenter =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.wireCenter;
      const productRequest = {
        productCode: "",
        wirecenter: wirecenter,
        addressDetailId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.addressId,
        "billingType": reduxStore?.user?.data?.billingType,
        "promoCode": "",
        partnerOrderId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId,
        interestedInSelfInstallOrTechInstall: "Tech",
        "propertyId": reduxStore?.addressQualification?.data?.addressQualification?.entity?.propertyId,
        "customerType":"" ,
        "lineType": "",
        "speed": ""
      }
      const payload = {
        baseline: {
          transactionId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId,
          channel: "web-acm",
          siteId: headers?.siteId
            ? ["qf", "qf-ii", "quantum fiber"]?.includes(
                headers?.siteId?.toLowerCase()
              )
              ? "qf"
              : headers?.siteId?.toLowerCase()
            : "", 
            wirecenter: wirecenter,
            intent: '',
           workflow: isMoveSupplementOrderEnabled ? "mover" : supplementOrderEligible ? "buyflow": "change",
            partnerOrderId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId,
        },
        productRequest
      };
      let url=API_URLS['getVoiceProductUrl'];
      const params = {
        "": [url],
      };
      const response = await getVoiceProduct(params, payload, headers);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  {
    // Skip only if a voice request is already in flight (prevents same-tick duplicate dispatches).
    // Explicit refetches (e.g., after cancel voice) are still allowed.
    condition: (_arg, { getState }) => {
      const state: any = getState();
      const slice = state?.getProductCategoriesSlice;
      if (slice?.voiceProductLoading) return false;
      return true;
    },
  }
);

export const getV2PostPaidVoiceProducts = createAsyncThunk(
  "voiceproduct/shopExp",
  async (_,{rejectWithValue}) => {
    
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const siteId=reduxStore?.addressQualification?.data?.addressQualification?.entity?.siteId;
      let supplementOrderEligible = reduxStore?.brightSpeedUserUtils?.isSupplementOrderEligible;
      let isMoveSupplementOrderEnabled = reduxStore?.brightSpeedUserUtils?.isMoveSupplementOrderEligible;
      const wirecenter =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.wireCenter;
      const planDetails = reduxStore?.planDetails?.planDetails;                    
      
      const tnNumber = planDetails?.pricing?.pots?.[0]?.tnNumber;
      const bundleCode = new Set();
      const pricePlanCode = new Set();
      const featureCodeList = new Set();
      let baseline: any = {};
      let productsRequest: any = {};
      planDetails?.standardPlans?.forEach(
        (subInfo:any) => {
          if (tnNumber === subInfo?.productSku) {
            bundleCode.add(subInfo?.bundleCode);
            pricePlanCode.add(subInfo?.productRatePlanId);
          }
        }
      );
 
      for (const product of planDetails?.existingOptionalFeatureDetail?.[0]?.existingOptionalFeatureDetails ?? []) {
        featureCodeList.add(product?.featureCode);
      }
 
      productsRequest.bundleCode = Array.from(bundleCode);
      productsRequest.pricePlanCode = Array.from(pricePlanCode);
      productsRequest.featureCodeList = Array.from(featureCodeList);
      const productRequest = {
        productCode: "",
        wirecenter: wirecenter,
        addressDetailId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.addressId,
        "billingType": reduxStore?.user?.data?.billingType,
        "promoCode": "",
        partnerOrderId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId,
        interestedInSelfInstallOrTechInstall: "Tech",
        "propertyId": reduxStore?.addressQualification?.data?.addressQualification?.entity?.propertyId,
        "customerType":"" ,
        "lineType": "",
        "speed": "",
        bundleCode: productsRequest?.bundleCode,
        pricePlanCode: productsRequest?.pricePlanCode,
        featureCodeList: productsRequest?.featureCodeList,
        fiberVoiceEligible : reduxStore?.addressQualification?.data?.addressQualification?.entity?.fiberVoiceEligible,
        productType : "FV",
      }
      const payload = {
        baseline: {
          transactionId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId,
          channel: "web-acm",
          siteId: headers?.siteId
            ? ["qf", "qf-ii", "quantum fiber"]?.includes(
                headers?.siteId?.toLowerCase()
              )
              ? "qf"
              : headers?.siteId?.toLowerCase()
            : "", 
            wirecenter: wirecenter,
            intent: isMoveSupplementOrderEnabled ? "supplement" : '',
            revisionType: isMoveSupplementOrderEnabled ? "supplement" : "",
            partnerOrderId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId,
             "workflow": isMoveSupplementOrderEnabled ? "mover" : supplementOrderEligible ? "buyflow": "change",
            "billingType": reduxStore?.user?.data?.billingType,
        },
        productRequest
      };
      
      const params = {
        "": [API_URLS?.getVoiceProductUrl],
      };
      const response = await getVoiceProduct(params, payload, headers);
      if(reduxStore?.planDetails?.ctlPlanDetails && Array.isArray(reduxStore?.planDetails?.ctlPlanDetails) && reduxStore?.planDetails?.ctlPlanDetails.length){
      const voicePlanName = reduxStore?.planDetails?.ctlPlanDetails[0]?.pots[0]?.productIdDescription;
      let productGroups = response?.data?.productResponse?.product?.productGroups;
     const indexToRemove = productGroups?.findIndex((product:any) =>  (product?.productName?.toLowerCase()?.includes("fiber voice") && product?.productName?.trim() !== voicePlanName?.trim()));
      if (indexToRemove > -1) {
        productGroups.splice(indexToRemove, 1); // 2nd parameter is the number of elements to remove
      }
      }
 
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
  {
    // Skip only if a postpaid voice request is already in flight (prevents same-tick duplicate dispatches).
    // Explicit refetches (e.g., after cancel voice) are still allowed.
    condition: (_arg, { getState }) => {
      const state: any = getState();
      const slice = state?.getProductCategoriesSlice;
      if (slice?.voiceProductLoading) return false;
      return true;
    },
  }
);

export const getV2DSLVoiceProducts = createAsyncThunk(
  "voiceproduct/DSLVoiceProducts",
  async (_,{rejectWithValue}) => {
    
    try {
      const reduxStore = store.getState();
      const headers = reduxStore?.brightspeedToken?.headers;
      const siteId= headers?.siteId?.toLowerCase();
      const user= reduxStore?.user?.data;
      const wireCenter =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.wireCenter;
            const mmmCode =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.marketingProfile?.mmmCode;
      const uploadSpeed =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.qualificationDetails?.maxUpBandwidth;
      const downloadSpeed =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.qualificationDetails?.maxDownBandwidth;
      const fiberVoiceEligible = reduxStore?.addressQualification?.data?.addressQualification?.entity?.fiberVoiceEligible || false;
      const transactionId = reduxStore?.addressQualification?.data?.addressQualification?.entity?.partnerSessionId;

      const planDetails = reduxStore?.planDetails?.planDetails;                    
      
      const tnNumber = planDetails?.pricing?.pots?.[0]?.tnNumber;
      const bundleCode = new Set();
      const pricePlanCode = new Set();
      const featureCodeList = new Set();
      let baseline: any = {};
      let productsRequest: any = {};
      planDetails?.standardPlans?.forEach(
        (subInfo:any) => {
          if (tnNumber === subInfo?.productSku) {
            bundleCode.add(subInfo?.bundleCode);
            pricePlanCode.add(subInfo?.productRatePlanId);
          }
        }
      );
 
      for (const product of planDetails?.existingOptionalFeatureDetail?.[0]?.existingOptionalFeatureDetails ?? []) {
        featureCodeList.add(product?.featureCode);
      }
 
      productsRequest.bundleCode = Array.from(bundleCode);
      productsRequest.pricePlanCode = Array.from(pricePlanCode);
      productsRequest.featureCodeList = Array.from(featureCodeList);
      const currentPlanPrice = planDetails?.pricing?.pots?.[0]?.pricing;
      productsRequest.currentPlanPrice = Number(currentPlanPrice);
      productsRequest.basePlanPrice = Number(planDetails?.pricing?.pots?.[0]?.basePlanPrice ?? currentPlanPrice);
 
        baseline.partnerId = "BS196123";
        baseline.salesCode = "20000660";
        baseline.partnerReferenceId = "";
        baseline.channel = "web-acm";
        baseline.workflow = "migratecoppertofiber";
        productsRequest.productType = "FV";
  
      const productRequest = {
        productCode:"",
        wirecenter: wireCenter,
        wireCenter: wireCenter,
        addressDetailId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.addressId,
        billingType: user?.billingType,
        promoCode: "",
        partnerOrderId: transactionId,
        interestedInSelfInstallOrTechInstall: "Tech",
        propertyId: reduxStore?.addressQualification?.data?.addressQualification?.entity?.propertyId,
        customerType:"" ,
        lineType: "",
        bundleCode: productsRequest?.bundleCode,
        pricePlanCode: productsRequest?.pricePlanCode,
        featureCodeList: productsRequest?.featureCodeList,
        currentPlanPrice: productsRequest?.currentPlanPrice,
        basePlanPrice: productsRequest?.basePlanPrice,
        productType: productsRequest?.productType,
        fiberVoiceEligible: fiberVoiceEligible
      }
      const payload = {
        baseline: {
          transactionId: transactionId,
          partnerOrderId: transactionId,
          partnerId: baseline?.partnerId,
          salesCode: baseline?.salesCode,
          partnerReferenceId: "",
          agentId: "",
          channel: baseline.channel,
          siteId: "bs",
          wirecenter: wireCenter,
          intent: '',
          workflow: baseline?.workflow,
          billingType: user?.billingType
        },
          
        productRequest
      }

      
      const params = {
        "": [API_URLS?.getVoiceProductUrl],
      };
      const response = await getVoiceProduct(params, payload, headers);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getProductCategoriesSlice = createSlice({
  name: "product/getV2InternetProduct",
  initialState,
  reducers: {
    clearProductCategoriesSlice: (state) => {
      return initialState;
    },
    productCategoriesSliceSetInitialState: () => initialState,
    setExistingOrderDetails:(state, action: PayloadAction<any>) =>{
      return {
        ...state,
        existingOrderDetails: action.payload
      }
    },
    setVoipProducts: (state, action: PayloadAction<boolean>) => {
      state.voipProducts = action.payload;
    },
    setBaseline: (state, action: PayloadAction<any>) => {
      state.baseline = action.payload;
    },
    setAddress: (state, action: PayloadAction<any>) => {
      state.address = action.payload;
    },
    setSelectedAppointmentTimeslotData: (state, action: PayloadAction<any>) => {
      state.selectedAppointmentTimeslotData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getV2InternetProductData.pending, (state) => {
      state.internetProductLoading = true;
      state.productResponse = null
    });
    builder.addCase(getV2InternetProductData.fulfilled, (state, action) => {
      state.productResponse = action.payload;
      state.internetProductLoading = false;
      state.error = null;
    });
    builder.addCase(getV2InternetProductData.rejected, (state, action) => {
      state.productResponse = null;
      state.internetProductLoading = false;
      state.error = action.error;
    });
    builder.addCase(getV2DSLInternetProductData.pending, (state) => {
      state.dslInternetProductLoading = true;
    });
    builder.addCase(getV2DSLInternetProductData.fulfilled, (state, action) => {
      state.dslInternetProductResponse = action.payload;
      state.dslInternetProductLoading = false;
      state.error = null;
    });
    builder.addCase(getV2DSLInternetProductData.rejected, (state, action) => {
      state.dslInternetProductResponse = null;
      state.dslInternetProductLoading = false;
      state.error = action.error;
    });

    builder.addCase(getV2VoiceProducts.pending, (state) => {
      state.voiceProductLoading = true;
    });
    builder.addCase(getV2VoiceProducts.fulfilled, (state, action) => {
      state.productVoiceRes = action.payload;
      state.voiceProductLoading = false;
      state.error = null;
    });
    builder.addCase(getV2VoiceProducts.rejected, (state, action) => {
      state.productVoiceRes = null;
      state.voiceProductLoading = false;
      state.error = action.error;
    });
    builder.addCase(getV2DSLVoiceProducts.pending, (state) => {
      state.dslVoiceProductLoading = true;
    });
    builder.addCase(getV2DSLVoiceProducts.fulfilled, (state, action) => {
      state.dslVoiceProductResponse = action.payload;
      state.dslVoiceProductLoading = false;
      state.error = null;
    });
    builder.addCase(getV2DSLVoiceProducts.rejected, (state, action) => {
      state.dslVoiceProductResponse = null;
      state.dslVoiceProductLoading = false;
      state.error = action.error;
    });

    builder.addCase(fetchOrderDetailsv2.pending, (state) => {
      state.existingProductLoading = true;
    });
    builder.addCase(fetchOrderDetailsv2.fulfilled, (state, action) => {
      state.existingOrderDetails = action.payload;
      state.existingProductLoading = false;
      state.error = null;
    });
    builder.addCase(fetchOrderDetailsv2.rejected, (state, action) => {
      state.existingOrderDetails = null;
      state.existingProductLoading = false;
      state.error = action.error;
    });
    builder.addCase(PURGE, () => {
      return initialState;
    })
  },
});
export const {
  setExistingOrderDetails,
  setVoipProducts,
  setBaseline,
  setAddress,
  setSelectedAppointmentTimeslotData,
  clearProductCategoriesSlice,
  productCategoriesSliceSetInitialState
} = getProductCategoriesSlice.actions;
export default getProductCategoriesSlice.reducer;
